exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.content{margin-left:20px}div.registration{border:1pt solid #003767;margin-top:20px;margin-bottom:20px;padding:20px;border-radius:.25rem;width:inherit;vertical-align:middle;display:table;align-content:center;text-align:center;justify-content:center;align-self:stretch}div.table-row{display:table-row;text-align:left}.table-cell{display:table-cell;padding-right:10px}.link{text-decoration:underline;cursor:pointer}div.button-panel{margin:5px;vertical-align:middle;text-align:center}div.button-panel button{margin:2px}div.states-panel{margin:10px;vertical-align:middle;text-align:center}div.state-tile{margin:20px 5px;padding:.5rem 1rem;font-size:1rem;border:1pt solid;border-radius:.25rem;display:inline-block;text-transform:lowercase}div.state-tile:first-letter{text-transform:capitalize}.no-text-transform{text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/queues-handling/queues-handling.component.css
// module id = 317
// module chunks = 0